import { DataProvider } from 'react-admin'
import { NotificationCategoryDto } from '../../dto/system-notifications/notification-category.dto'

const fakeCategories: NotificationCategoryDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeCategories, total: fakeCategories.length }),
} as DataProvider

export default provider
